import { AssignmentDTO, CreateAssignmentRequest } from '@/models';
import { axiosClient } from '../http/axiosClient';

const assignmentPath = (institutionId: string, userId: string) =>
  `/institutions/${institutionId}/users/${userId}/assignments`;

export const assignmentService = {
  getAll: async (
    institutionId: string,
    userId: string,
    includeInactive = false
  ): Promise<AssignmentDTO[]> => {
    const response = await axiosClient.get<AssignmentDTO[]>(assignmentPath(institutionId, userId), {
      params: { includeInactive },
    });
    return response.data;
  },

  create: async (
    institutionId: string,
    userId: string,
    data: CreateAssignmentRequest
  ): Promise<AssignmentDTO> => {
    const response = await axiosClient.post<AssignmentDTO>(
      assignmentPath(institutionId, userId),
      data
    );
    return response.data;
  },

  revoke: async (institutionId: string, userId: string, assignmentId: string): Promise<void> => {
    await axiosClient.post(`${assignmentPath(institutionId, userId)}/${assignmentId}/revoke`, {});
  },
};

export default assignmentService;
